import Headings from '../components/ui/containers/Headings/Headings';
import {useTranslation} from 'react-i18next';

import AgendaBlock from '../components/layout/Agenda/Agenda';
import {push} from '../helpers/seo';

function PastAgenda() {
  const {t} = useTranslation('agenda');

  push({
    title:       'Past Agenda',
    description: t('seo.description'),
    keywords:    'agenda, concerts, events, shows, dates, tickets, past'
  });

  return (
    <div>
      <Headings title={t('headings.past_title')} text={t('headings.past_message')}/>
      <AgendaBlock showPastOnly={true}/>
    </div>
  );
}

export default PastAgenda;
